import React from "react";

export default function Banner() {
  return (
    <div className="banner">
      <div className="banner-item">
        <div className="icon">{/* Icône téléchargement */}</div>
        <div>
          <p className="title">Ultra rapide</p>
          <p className="subtitle">Téléchargement instantané</p>
        </div>
      </div>

      <div className="banner-item">
        <div className="icon shield">{/* Icône bouclier */}</div>
        <div>
          <p className="title">Fiable et sûr</p>
          <p className="subtitle">Plus de 10 000 jeux</p>
        </div>
      </div>

      <div className="banner-item">
        <div className="icon chat">{/* Icône chat */}</div>
        <div>
          <p className="title">Service client</p>
          <p className="subtitle">Conseillers disponibles 24/7</p>
        </div>
      </div>

      <div className="banner-item">
        <div className="icon trust">{/* Icône étoiles */}</div>
        <div>
          <p className="title">Trustpilot</p>
          <p className="subtitle">
            TrustScore <strong>4.7</strong> · 769 093 avis
          </p>
        </div>
      </div>
    </div>
  );
}